import getEnv from "@/config/env";
import _ from "lodash";

export const CAPTCHA_SITE_KEY = getEnv("VUE_APP_CAPTCHA_SITE_KEY");
export const NUMBER_FORMAT_LOCALE = "en-US";
export const CURRENCY = "USD";
export const ES_WINDOW_LIMIT = 10000;
export const IMAGE_KEYS = ['pictures', 'large_pictures', 'small_pictures'];
export const TEXT_KEYS = ['description', 'description_html', 'guide', 'short_description'];
export const SEGMENTS = {
  Maira: 'Maira',
  PERSONALIZER: 'Personalizer',
  CV: 'CV'
};

export const SEGMENTS_TAB_STORAGE_KEYS = {Maira : "savedMairaTab", PERSONALIZER : "savedPersonalizerTab",CV: "savedCVTab" }

export const GPT_SETUP_STEPS = ['embedding', 'dataset', 'training', 'gpt_profile'];

export const MAIRA_TABS = ["mairaQuestionnaire"]
export const PERSONALIZER_TABS = ["datasets","dataUpdate","aiResponse"]
export const COMMON_TABS = ["settings", "insights", "details", "emailConfig", "broadcast", "mairaDatasets", "mairaProfiles", "mairaSetting", "designMaira", "access"]

export const PROMPT_TEMPLATE_SEPARATORS_TOKEN_COUNT = 100

export const HISTORY_TYPES = {
  CONVERSATION: "conversation",
  QUESTIONNAIRE: "questionnaire",
  MAIRA_QUESTIONNAIRE: "maira_questionnaire",
  SESSION: "session"
}

export const GPT_PROFILE_INIT_SYSTEM = "You are an expert on COMPANY_NAME/PERSONA/TOPIC. BRIEF INTRODUCTION ABOUT THE COMPANY/PERSONA/TOPIC.";

export const GPT_PROFILE_INIT_DATA = {
  name: "",
  intro: "",
  system: GPT_PROFILE_INIT_SYSTEM,
  model: "",
  provider: "",
  temperature: 0,
  top_p: 1,
  top_k: 20,
  frequency_penalty: 0,
  presence_penalty: 0,
  stop: [],
  search_max_token: 2500,
  completion_token: 2000,
  vision_settings: {
    resolution: "low",
    is_image_context_enabled: true,
    is_conversation_learning: false,
  },
  is_conversation_adding: false,
  is_background_ask: false,
  id: undefined,
  access_tags: [],
  dataset_tags: {
    includes: [],
    excludes: [],
  },
  chat_history_length: 0,
  is_personalizer_only: false,
  is_auto_evaluation: false,
  search_mode: null,
  dataset_languages: [],
  is_lang_auto_detect: true,
  content_moderation: {},
  external_system_configs: [],
  response_filters: [],
  questionnaire_config: [],
  office_hour_start: null,
  office_hour_end: null,
  out_of_office_message: null,
  max_concurrent_sessions: null,
  session_limit_reached_message: null,
  session_already_finished_message: null,
  session_timeout_minutes: null,
  tools: [],
  is_citation_enabled: false,
  time_series_config: {
    require_user_confirmation: false,
    show_reference_fields: false,
    default_timezone: null,
  },
};

export const CONTAMINATION_CONTEXTS = {
  INCLUDE: 'includes',
  EXCLUDE: 'excludes'
};

export const RESPONSE_FILTER_TYPES = {
  PLAIN: 'plain',
  REGEX: 'regex'
};

export const MAX_DATASET_NAME_LENGTH = 30;


export const DELIVERY_MODES = {
  IMMEDIATE: "immediate",
  SCHEDULED: "scheduled"
};

export const ONE_DIRECTIONAL_CONFIG_INIT_DATA = () => ({
  email_template: {
    email_subject: "",
    email_body: ""
  },
  senders: [],
  recipients: [],
  delivery_mode: DELIVERY_MODES.IMMEDIATE,
  schedules: []
});

export const MAIRA_QUESTIONNAIRE_INIT_DATA = () => ({
  name: "",
  questions: [],
  context_template: "",
  active: true,
  response_instructions: "",
  is_one_directional: false,
  one_directional_config: ONE_DIRECTIONAL_CONFIG_INIT_DATA()
});

export const GPT_DATASET_TEMPLATE = {
  name: "",
  idx_column_name: null,
  is_idx_fillup_if_empty: true,
  secondary_idx_column: null,
  image_url_column: null,
  description: null,
  tags: [],
  dataset_id: null,
  filterable_fields: [],
  created_at: null,
  updated_at: null,
  url: null,
  scraping_mode: null,
  update_frequency: null,
  documents_count: {
    total: 0,
    active: 0,
    text_trained: 0,
    image_trained: 0
  }
};

export const initGptDataset = () => _.cloneDeep(GPT_DATASET_TEMPLATE);

export const GPT_CONVERSATION_REINDEX_PAYLOAD_TEMPLATE = {
  is_background_task: true,
  index_type: 'gpt_conversation',
  mappings: {
    settings: {
      analysis: {
        char_filter: {
          normalize: { type: 'icu_normalizer', name: 'nfkc', mode: 'compose' },
        },
        tokenizer: {
          ja_kuromoji_tokenizer: {
            type: 'kuromoji_tokenizer',
            mode: 'search',
            discard_compound_token: true,
            user_dictionary_rules: [],
          },
          ja_ngram_tokenizer: {
            type: 'ngram',
            min_gram: 2,
            max_gram: 3,
            token_chars: ['letter', 'digit'],
          },
        },
        filter: {
          ja_index_synonym: { type: 'synonym', lenient: false, synonyms: [] },
          ja_search_synonym: { type: 'synonym_graph', lenient: true, synonyms: [] },
        },
        analyzer: {
          ja_kuromoji_index_analyzer: {
            type: 'custom',
            char_filter: ['normalize'],
            tokenizer: 'ja_kuromoji_tokenizer',
            filter: [
              'kuromoji_baseform',
              'kuromoji_part_of_speech',
              'ja_index_synonym',
              'cjk_width',
              'ja_stop',
              'kuromoji_stemmer',
              'lowercase',
            ],
          },
          ja_kuromoji_search_analyzer: {
            type: 'custom',
            char_filter: ['normalize'],
            tokenizer: 'ja_kuromoji_tokenizer',
            filter: [
              'ja_search_synonym',
              'kuromoji_baseform',
              'kuromoji_part_of_speech',
              'cjk_width',
              'ja_stop',
              'kuromoji_stemmer',
              'lowercase',
            ],
          },
          ja_ngram_index_analyzer: {
            type: 'custom',
            char_filter: ['normalize'],
            tokenizer: 'ja_ngram_tokenizer',
            filter: ['lowercase'],
          },
          ja_ngram_search_analyzer: {
            type: 'custom',
            char_filter: ['normalize'],
            tokenizer: 'ja_ngram_tokenizer',
            filter: ['ja_search_synonym', 'lowercase'],
          },
        },
      },
    },
    mappings: {
      properties: {
        created_at: { type: 'date' },
        updated_at: { type: 'date' },
        request_body: {
          properties: {
            query: {
              type: 'text',
              analyzer: 'ja_kuromoji_index_analyzer',
              search_analyzer: 'ja_kuromoji_search_analyzer',
              fielddata: true,
              fields: {
                keyword: { type: 'keyword', ignore_above: 256 },
              },
            },
          },
        },
      },
    },
  },
};

export const buildGptConversationReindexPayload = () =>
  _.cloneDeep(GPT_CONVERSATION_REINDEX_PAYLOAD_TEMPLATE);

// Content type constants
export const CONTENT_TYPES = {
  IMAGE: 'image',
  PDF: 'pdf',
  JSON: 'json',
  CSV: 'csv',
  TEXT: 'text'
};

export const ENDPOINT_TYPES = Object.freeze({
  ASK: "Ask",
  VISION: "Vision",
  REALTIME: "Realtime",
  QUESTIONNAIRE: "Questionnaire",
  UNKNOWN: "N/A",
});

export const ENDPOINT_PATHS = Object.freeze({
  ASK: "/v1/maira/ask",
  VISION: "/v1/maira/vision",
  REALTIME: "/v1/realtime/ws",
  QUESTIONNAIRE: "/v1/maira/questionnaire/interact",
});
